import ListTechVisits from "@/views/service_provider/tech_visits/query/ListTechVisits.vue";
import ShowTechVisit from "@/views/service_provider/tech_visits/query/ShowTechVisit.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "sp",
  role: "tech_visits",
  permission: "query",
});

export default [
  {
    path: "/service_provider/:service_provider_id/tech_visits/query",
    name: routeName(""),
    component: ListTechVisits,
    props: true,
    meta: META
  },
  {
    path: "/service_provider/:serviceProviderId/tech_visits/query/show_tech_visit/:techVisitId",
    name: routeName("show_tech_visit"),
    component: ShowTechVisit,
    props: true,
    meta: META
  },
];
